export default "/images/ec5cbeefc90ceee65e35f1566e12bd98.avif";